import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import ProgressMetric from './ProgressMetric'
import { metricDataPropType } from '../Utils/types'

export default function CompactMetric({ label, data, colour }) {
  const percentage =
    data.target > 0 ? Math.round((data.value / data.target) * 100) : 0

  return (
    <Box display="flex" alignItems="center" mb={2} sx={{ gap: 1.5 }}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: colour,
          flexShrink: 0,
        }}
      />

      <Typography
        variant="body2"
        sx={{
          width: 90,
          color: '#aaa',
          flexShrink: 0,
        }}
      >
        {label}
      </Typography>

      <Box flexGrow={1}>
        <ProgressMetric label={label} data={data} colour={colour} />
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: colour,
          fontWeight: 700,
          width: 42,
          textAlign: 'right',
          flexShrink: 0,
        }}
      >
        {`${percentage}%`}
      </Typography>
    </Box>
  )
}

CompactMetric.propTypes = {
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  data: metricDataPropType.isRequired,
}
